"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const MetadataModal_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/Modals/MetadataModal.vue"));
const WarningModal_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/Modals/WarningModal.vue"));
const lucide_vue_next_1 = require("lucide-vue-next");
const Template_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/metadata/Template"));
const CSVMetadata_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/metadata/CSVMetadata"));
let Metadata = class Metadata extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.loaded_filename = null;
        this.csv = null;
        this.triggerTheMetadataModal = false;
        this.triggerTheWarningModal = false;
        this.triggerTheWarningModal2 = false;
    }
    get file_input() {
        const file_input = this.$refs.input_file;
        if (!file_input)
            throw "No input file";
        return file_input;
    }
    onUpload() {
        if (this.heatmap.empty()) {
            this.onUpload2();
        }
        else {
            this.triggerTheWarningModal = true;
        }
    }
    onUpload2() {
        this.heatmap.rmAll();
        this.file_input.click();
    }
    onRemoveCSV() {
        if (this.heatmap.empty()) {
            this.onRemoveCSV2();
        }
        else {
            this.triggerTheWarningModal2 = true;
        }
    }
    onRemoveCSV2() {
        this.heatmap.rmAll();
        this.csv = null;
        this.loaded_filename = null;
    }
    downloadTemplate() {
        const samples = this.heatmap.librarySamples.samples.map(s => s.sample);
        const template = new Template_1.default();
        template.build(samples);
        template.download();
    }
    async onChangeFile(event) {
        const file = event.target.files[0];
        if (!file)
            return;
        const csv = new CSVMetadata_1.default();
        await csv.parse(file);
        this.csv = csv;
        if (this.heatmap.root) {
            this.triggerTheMetadataModal = true;
        }
        else {
            this.triggerTheMetadataModal = true;
        }
        this.file_input.value = '';
    }
    async metadataLoaded() {
        if (!this.csv) {
            throw "No CSV";
        }
        this.loaded_filename = this.csv.filename;
        this.heatmap.importCSVMetadata(this.csv);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], Metadata.prototype, "heatmap", void 0);
Metadata = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Check: lucide_vue_next_1.Check,
            X: lucide_vue_next_1.X,
            MetadataModal: MetadataModal_vue_1.default,
            WarningModal: WarningModal_vue_1.default,
        }
    })
], Metadata);
exports.default = Metadata;
